import { Avatar, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { BOOKING_STATUS } from '~graphql-types';
import { PortraitDefault } from '~svg-components';
import StudentAvatarIcon from './student-avatar-status-icon';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      ...theme.flex.center,
      display: 'inline-flex',
      width: 40,
      height: 40,
      borderRadius: '50%',
    },

    avatar: {
      width: 'inherit',
      height: 'inherit',
    },

    defaultAvatar: {
      width: '100%',
      height: '100%',
    },
    container: {
      position: 'relative',
      width: '100%',
      height: '100%',
    },
  }),
  { name: 'StudentAvatar' }
);

const LEVEL_0 = 0;
const LEVEL_1 = 1;
const LEVEL_2 = 2;
const LEVEL_3 = 3;
const LEVEL_4 = 4;
const LEVEL_5 = 5;
const LEVEL_6 = 6;
const LEVEL_7 = 7;
const LEVEL_8 = 8;
const LEVEL_9 = 9;
const LEVEL_10 = 10;

export const STATUS_LEVEL_MAPPING = {
  [BOOKING_STATUS.RESIDENT]: LEVEL_10,
  [BOOKING_STATUS.BOOKING_COMPLETED]: LEVEL_9,
  [BOOKING_STATUS.BOOKING_CONFIRMED]: LEVEL_8,
  [BOOKING_STATUS.APPLIED]: LEVEL_7,
  [BOOKING_STATUS.ROOM_SELECTED]: LEVEL_6,
  [BOOKING_STATUS.SELECTION_COMPLETED]: LEVEL_5,
  [BOOKING_STATUS.TERMS_ACCEPTED]: LEVEL_4,
  [BOOKING_STATUS.PAST]: LEVEL_3,
  [BOOKING_STATUS.ENQUIRY]: LEVEL_2,
  [BOOKING_STATUS.CANCELLED]: LEVEL_1,
  [BOOKING_STATUS.EXPIRED]: LEVEL_0,
};

const StudentAvatarWithStatus = React.forwardRef((props, ref) => {
  const { bookings, src, className, StatusIconProps, ...otherProps } = props;
  const avatarSrc = src ? `${process.env.REACT_APP_FILE_SERVICE_URL}/files/${src}` : undefined;

  const classes = useStyles();

  const topStatus = useMemo(() => {
    let status = BOOKING_STATUS.EXPIRED;
    bookings?.forEach((booking) => {
      if (STATUS_LEVEL_MAPPING[booking.status] > STATUS_LEVEL_MAPPING[status]) {
        status = booking.status;
      }
    });
    return status;
  }, [bookings]);

  return (
    <div {...otherProps} className={classNames(classes.root, className)} ref={ref}>
      <div className={classes.container}>
        <Avatar src={avatarSrc} className={classes.avatar}>
          <PortraitDefault className={classes.defaultAvatar} />
        </Avatar>

        {bookings && <StudentAvatarIcon status={topStatus} StatusIconProps={StatusIconProps} />}
      </div>
    </div>
  );
});

StudentAvatarWithStatus.propTypes = {
  bookings: PropTypes.array,
  src: PropTypes.string,
  className: PropTypes.string,
  StatusIconProps: PropTypes.object,
};

export default StudentAvatarWithStatus;
